var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.762 12-6.461-6-1.032 1.111 4.448 4.13H5v1.517h11.717l-4.448 4.13L13.3 18l6.461-6Z",
    fill: "currentColor"
  })));
};
export { SvgArrowRight as ReactComponent };
export default __webpack_public_path__ + "ba9a654cd29eb73a1286b79868c36652.svg";